import ApiResponse from "@/server/responses/ApiResponse";
import JokeTripMap from "@/server/structures/JokeTripMap";

export default class ApiResponse_GetMap extends ApiResponse {

    get map() {
        return new JokeTripMap(this._rawResponse.data);
    }
}
